module.exports = __webpack_public_path__ + "612698606760cf487e1741a80d829c67.png";


//////////////////
// WEBPACK FOOTER
// ./src/theme-files/image-resources/pattern-bg/pattern-bg-10.png
// module id = 414
// module chunks = 0